import { render, staticRenderFns } from "./MailEditComplete.vue?vue&type=template&id=1fa63845&lang=pug&"
import script from "./MailEditComplete.vue?vue&type=script&lang=ts&"
export * from "./MailEditComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports